import {withRequestsStatus} from '@ngneat/elf-requests';
import {withPagination} from '@ngneat/elf-pagination';
import {withEntities} from '@ngneat/elf-entities';
import {createStore, withProps} from '@ngneat/elf';
import {OrganisationConfig} from '@store/settings/organisationsConfig/organisationsConfig.model';
import {TablePagination} from '@store/common/pagination.model';
import {TableConfig} from '@constants/table.constants';

export interface OrganisationConfigState {
  tablePagination: TablePagination;
  filters: {
    search: string;
  };
}

export const organisationsConfigStore = createStore(
  {name: 'organisations-config'},
  withProps<OrganisationConfigState>({
    filters: {
      search: ''
    },
    tablePagination: {
      page: 1,
      limit: TableConfig.pagination,
    }
  }),
  withEntities<OrganisationConfig>(),
  withPagination(),
  withRequestsStatus(),
);
